import { render, staticRenderFns } from "./tower-canvas.vue?vue&type=template&id=4437ca3b&scoped=true&"
import script from "./tower-canvas.vue?vue&type=script&lang=js&"
export * from "./tower-canvas.vue?vue&type=script&lang=js&"
import style0 from "./tower-canvas.vue?vue&type=style&index=0&id=4437ca3b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4437ca3b",
  null
  
)

export default component.exports